
import request from '@/utils/request';
import config from '@/utils/config';
const host  = config.baseURL ?config.baseURL: config.mainURL;

export default{
    login(data) {
      return request({
        url: '/auth/login',
        method: 'post',
        data
      })
    },
    getInfo(params) {
        return request({
          url: '/auth/info',
          method: 'get',
          params: { params }
        })
    },
    logout() {
        return request({
          url: '/auth/logout',
          method: 'post'
        })
    },
    saveAllConfig(data){
      return request({
        url: '/config/all',
        method: 'post',
        data
      })
    },
    deleteConfig(params){
      return request({
        url: '/config/delete',
        method: 'get',
        params
      })
    },
    get(path, params) {
      return request({
        url: path,
        method: 'get',
        params
      })
    },
    post(path, data) {
      return request({
        url: path,
        method: 'post',
        data
      })
    },
    appGet(path,appId, params) {
      return request({
        url: path,
        method: 'get',
        params,
        headers: {
          "MT-APP-ID": appId
        }
      })
    },
    appPost(path, appId,data) {
      return request({
        url: path,
        method: 'post',
        data,
        headers: {
          "MT-APP-ID": appId
        }
      })
    },
    outPutExcel(payload) {
      var d = `
        <table border="1">
        <caption>${payload.title ? payload.title : ''}</caption>
        <tr>
          <th>${
        payload.head.map(item => { return item.name }).join('</th><th>')
      }</th>
        </tr>
        ${
        payload.list.map(item => {
          var r = payload.head.map(otem => {
            return '<td>' + item[otem.key] + '</td>';
          }).join('');
          return '<tr>' + r + '</tr>';
        }).join('')
      }
        </table>
      `;
      var blob = new Blob([d], { type: "application/vnd.ms-excel" });
      var fileName = (payload.title ? payload.title : '导出文件') + (+new Date()) + '.xls';
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      payload.callback && payload.callback();
    },
    httpGet(path, params) {
      console.log(global)
      return request({
          url: host + path,
          method: 'get',
          params
        })
    },
    httpPost(path,data) {
        return request({
          url:host + path,
          method: 'post',
          data
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/api.js